// extracted by mini-css-extract-plugin
export default {"innerWrapper":"tv-z","tooltipWrapper":"uv-z","icon":"vv-z","tooltip":"wv-z","content":"xv-z"};